import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import * as actions from "../actions"
import QuestionReport from "../../interview/components/QuestionReport"
import AgeInputHint from "./AgeInputHint"
import { colors } from "buoy-theme"
import { onSubmit } from "../../interview/handlers"
import { Button, FormInput, Paragraph } from "buoy-core"
import { inIframe } from "../../common/common"
import { FormattedMessage } from "react-intl"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`

const AgeContainer = styled.div`
  width: 150px;
  margin-bottom: 12px;
  padding-bottom: ${props => props.paddingBottom};
  display: flex;
  position: relative;
`

const SubmitButton = styled(Button)`
  width: 150px;
  margin-bottom: 8px;
`

const AgeInput = styled(FormInput)`
  width: 70px;
  margin: 0 12px 0 0;
  text-align: center;
  border: ${props => props.error ? `1px solid ${colors.error}` : "none"};

  &::placeholder {
    color: ${colors.neutral};
  }
`

const UnitLabel = styled(Paragraph)`
  padding-top: 12px;
`

const AgeResponse = ({...props}) => {

  const invalidInfantCopy = {
    heading: "If you’re concerned, it’s best to call your doctor.",
    text: ["Buoy Assistant is designed for people ages 2 and over. Since infants and younger children can become ill more quickly, they require a bit more caution.",
    "If you’re worried about an infant or young child, calling a doctor is best. If you think they need more immediate medical care, please bring them to a nearby emergency room or call 911. "]
  }

  const validate = () => {
    const { value } = props.age
    if (!value) return false
    return value.toString().match(RegExp(/^\d{1,3}$/))
  }

  const setAgeValue = e => {
    let val = e.target.value.replace(/\D/g, "").slice(0, 3)
    props.setAgeError(null)
    props.setAgeValue(val)
  }

  const onKeyPress = e => {
    let key = e.keyCode || e.which
    // do nothing if key is not Enter/Return or age is invalid
    if ( key !== 13 || !validate() ) return
    submit()
  }

  const onInputFocus = () => {
    let ageInput = document.getElementById('age-submit')
    let scrollTo = ageInput.offsetTop + window.innerHeight/2
    window.scrollTop = scrollTo
  }

  const resetError = () => {
    if (props.error) props.setAgeError(null)
  }

  const submit = () => {
    const { onSubmit, age, pov, setAgeError, setInfantExplanation } = props
    const { value } = age
    if (pov === "self" && (value < 13 || value > 120)) {
      setAgeError(true)
    } else if (pov === "other" && value < 2) {
      // handle if < 2
      setAgeError(true)
      setInfantExplanation(invalidInfantCopy)
    } else if (pov === "other" && value > 120) {
      setAgeError(true)
    } else {
      resetError()
      onSubmit()
    }
  }

  let { pov, age, error } = props
  let valid = validate()

  return (
    <Container>
      <AgeContainer>
        <AgeInput
          autoFocus={!inIframe()}
          pattern="\d*"
          fieldType="number"
          value={age.value || ""}
          placeholder="---"
          onKeyPress={onKeyPress}
          onChange={e => setAgeValue(e)}
          onFocus={onInputFocus}
          error={error}
        />
        <UnitLabel>
          <FormattedMessage
            id="identifiers.age.field"
            defaultMessage="years old"
          />
        </UnitLabel>
      </AgeContainer>
      <SubmitButton id="age-submit" margin="0 0 12px" onClick={submit} disabled={!valid}>
        <FormattedMessage
          id="identifiers.age.submit"
          defaultMessage="Submit"
        />
      </SubmitButton>
      <AgeInputHint pov={pov} error={error} value={age.value || ""} />
      <QuestionReport />
    </Container>
  )
}

const mapStateToProps = state => ({
  age: state.identifiers.age,
  pov: state.identifiers.pov,
  error: state.identifiers.ageError,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: () => dispatch(onSubmit(ownProps.item, dispatch)),
  setAgeValue: value => dispatch(actions._setAge({ value: value })),
  setAgeError: error => dispatch(actions.setAgeError(error)),
  setInfantExplanation: explanation => dispatch(actions.setInfantExplanation(explanation))
})

const AgeResponseWrapper = connect(mapStateToProps, mapDispatchToProps)(AgeResponse)

export { AgeResponseWrapper as default, AgeResponse }



// WEBPACK FOOTER //
// ./assets/identifiers/components/AgeResponse.js